"use client";

import { c as _c } from "react/compiler-runtime";
import { useTrialOnboardingProgressControllerFindForTrial } from "@dc/gateway-jsonapi";
import { selectTrialOnboardingProgress, trialOnboardingProgressParams } from "./trialOnboardingProgress.shared";
export function useTrialOnboardingProgress(trialId) {
  const $ = _c(9);
  let t0;
  if ($[0] !== trialId) {
    t0 = trialOnboardingProgressParams(trialId);
    $[0] = trialId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const params = t0;
  const t1 = Boolean(trialId);
  let t2;
  if ($[2] !== t1) {
    t2 = {
      query: {
        enabled: t1,
        select: selectTrialOnboardingProgress
      }
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    error,
    isPending,
    refetch
  } = useTrialOnboardingProgressControllerFindForTrial(params, t2);
  const t3 = Boolean(trialId) && isPending;
  let t4;
  if ($[4] !== data || $[5] !== error || $[6] !== refetch || $[7] !== t3) {
    t4 = {
      progress: data,
      isLoading: t3,
      error,
      refetch
    };
    $[4] = data;
    $[5] = error;
    $[6] = refetch;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export type TrialOnboardingProgressQuery = ReturnType<typeof useTrialOnboardingProgress>;